<template>
    <div class="main_body">
        <loading :active="isLoading" :is-full-page="fullPage" :loader="loader" />
        <div class="container-fluid">
            <div class="row row-cols-2 row-cols-md-3 row-cols-lg-4 g-3">
                <div style="margin-left:20px;" class="pb-4">
                <h3>Signup History Channel</h3>
            </div>
            </div>

            <div>
                <h3 style="color:white;">Select platform</h3>
                <form @submit.prevent="processForm">
                    <select v-model="platform" id="cars">
                        <option style="display:none;" selected value="">Select one</option>
                        <option value="web">Web</option>
                        <option value="android">Android</option>
                    </select><br><br>
                    <button class="btn btn-success">Submit</button>
                </form>

            </div>
            <div style="overflow-x:auto">
                <table class="table" style="">
                    <tr v-if="flags===true">
                        <th>User Name</th>
                        <th>Full Name</th>
                        <th>Phone no</th>
                        <th>City</th>
                        <th>Address</th>
                        <th>Post Code</th>
                        <!-- <th>Auth Source</th> -->
                        <!-- <th>Channel</th> -->
                        <th>Premium</th>
                        <!-- <th>Image Url</th> -->
                        <!-- <th>User Fb ID</th> -->
                        <!-- <th>Deleted</th> -->
                        <!-- <th>Package ID</th> -->
                    </tr>
                    <tr v-for="(data, index) in signupHistoryList" :key="index">
                        <td>{{ data.user_name }}</td>
                        <td>{{ data.full_name }}</td>
                        <td>{{ data.phone_no }}</td>
                        <td>{{ data.city }}</td>
                        <td>{{ data.address }}</td>
                        <td>{{ data.post_code }}</td>
                        <!-- <td>{{ data.auth_src }}</td> -->
                        <!-- <td>{{ data.channel }}</td> -->
                        <td>{{ data.premium }}</td>
                        <!-- <td><img width="100%" :src="data.image_url" alt=""> </td> -->
                        <!-- <td>{{ data.user_id_fb }}</td> -->
                        <!-- <td>{{ data.deleted }}</td> -->
                        <!-- <td>{{ data.package_id }}</td> -->

                    </tr>
                </table>
                <table v-if="flags===false" class="table" style="">
                <thead>
                    <tr>
                        <th>No</th>
                        <th>User Name</th>
                        <th>Full Name</th>
                        <th>Phone no</th>
                        <th>City</th>
                        <th>Address</th>
                        <th>Post Code</th>
                        <!-- <th>Auth Source</th> -->
                        <!-- <th>Channel</th> -->
                        <th>Premium</th>
                        <!-- <th>Image Url</th> -->
                        <!-- <th>User Fb ID</th> -->
                        <!-- <th>Deleted</th> -->
                        <!-- <th>Package ID</th> -->
                        <th>Signup Time</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(data, index) in lists" :key="index">
                    <td>{{index+1}}</td>
                        <td>{{ data.user_name }}</td>
                        <td>{{ data.full_name }}</td>
                        <td>{{ data.phone_no }}</td>
                        <td>{{ data.city }}</td>
                        <td>{{ data.address }}</td>
                        <td>{{ data.post_code }}</td>
                        <!-- <td>{{ data.auth_src }}</td> -->
                        <!-- <td>{{ data.channel }}</td> -->
                        <td>{{ data.premium }}</td>
                        <!-- <td><img width="100%" :src="data.image_url" alt=""> </td> -->
                        <!-- <td>{{ data.user_id_fb }}</td> -->
                        <!-- <td>{{ data.deleted }}</td> -->
                        <!-- <td>{{ data.package_id }}</td> -->
                        <td>{{data.created_at | formatDate}}</td>

                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import Loading from "vue-loading-overlay";
export default {
    data() {
        return {
            signupHistoryList: "",
            platform: "",
            flags:false,
            lists:"",
            isLoading: false,
      fullPage: true,
      loader: "bars",
        }
    },

    components:{
        Loading
    },

    created() {
        this.dynamicList()
    },
    methods: {
        processForm() {
            if (this.checkForm) {
                this.flags=true
                this.list()
            }
        },
        checkForm() {
            if (this.platform) {
                return true
            }
            this.errors = [];
            if (!this.platform) {
                this.errors.push("Platform required")
                return false
            }
        },
        async list() {
            const token = localStorage.getItem(this.$tokenKey);
            try {
                const res = await axios.get(
                    this.$baseUrl + this.$api + this.$version1 + "/kabbikanalytics/signup-history-channel?fromChannel='" +this.platform +"'", {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    }
                }
                );
                if (res.status == 200) {
                    this.signupHistoryList = res.data
                }
            } catch (error) {
                console.log(error);
                this.isLoading = false;
            }
        },
        async dynamicList(){
            const token = localStorage.getItem(this.$tokenKey);
            try {
                this.isLoading=true
                const res = await axios.get(
                    this.$baseUrl + this.$api + this.$version1 + "/kabbikanalytics/signup-history-channel?fromChannel='web'", {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    }
                }
                );
                if (res.status == 200) {
                    this.lists = res.data
                    this.isLoading=false
                }
            } catch (error) {
                console.log(error);
                this.isLoading = false;
            }
        }
    }
}
</script>